import { rootStore } from 'store/root';

const { nxlApi, dataLayer } = window;

const CLASS_PREFIX = 'lang-';

const setClassLang = (lng: string) => {
    const body = document.querySelector('body');
    if (!body) return;
    const currLngClass = body.className.split(' ').find(cName => cName.indexOf(CLASS_PREFIX) >= 0);
    if (!currLngClass) return;
    body.className = body.className.replace(currLngClass, `${CLASS_PREFIX}${lng}`);
};

export default nxlApi.localization.sub((key: string, data: any) => {
    switch (key) {
        case 'setLocale':
            rootStore.systemInfo.changeLanguage(data.locale);
            dataLayer.push({ language: data.locale.toLowerCase().replace('_', '-') });
            setClassLang(data.locale);
            break;
    }
});
